import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profesionales-form-dialog',
  templateUrl: './profesionales-form-dialog.component.html',
  styleUrls: ['./profesionales-form-dialog.component.scss']
})
export class ProfesionalesFormDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
